import AccessCodeGate from '../components/AccessCodeGate';
import { laravelAsset } from '../services/accessCodeService';

function AccessEbook() {
  return (
    <AccessCodeGate
      type="EBOOK"
      title="EBOOK"
      imageSrc={laravelAsset('images/new/2.png')}
      buttonLabel="ACCESS EBOOK"
    />
  );
}

export default AccessEbook;
